<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 511.997 511.997" style="enable-background:new 0 0 511.997 511.997;" xml:space="preserve">
<g>
	<g>
		<path d="M489.252,393.782l-80.487-171.855c-1.756-3.751-6.222-5.366-9.974-3.611c-3.751,1.757-5.368,6.223-3.611,9.974
			l80.486,171.851c3.6,7.699,0.268,16.896-7.428,20.502l-154.316,72.268c-7.695,3.605-16.89,0.276-20.497-7.42l-28.851-61.621
			l75.093-181.18c3.245-7.831,3.063-16.732-0.497-24.423l-41.075-88.727l53.243,16.844c4.097,1.294,7.489,4.266,9.309,8.162
			l19.722,42.094c1.275,2.722,3.977,4.32,6.797,4.32c1.065,0,2.148-0.229,3.177-0.71c3.751-1.757,5.367-6.224,3.609-9.975
			l-19.719-42.087c-3.588-7.682-10.287-13.553-18.375-16.107l-64.21-20.314c13.238-19.338,27.183-45.197,31.981-56.774
			c12.582-30.356,2.427-47.238-11.271-52.916c-13.699-5.676-32.818-0.927-45.4,29.429c-5.411,13.056-10.376,41.49-13.907,65.883
			c-4.202,0.261-8.426,1.141-12.54,2.714l-97.147,37.118c-7.772,2.97-14.057,9.082-17.243,16.767L22.216,404.693
			c-3.111,7.506-3.113,15.773-0.005,23.28c3.107,7.507,8.952,13.354,16.457,16.464l30.39,12.595c3.827,1.586,8.216-0.23,9.801-4.057
			c1.586-3.827-0.23-8.215-4.057-9.801l-30.39-12.596c-3.803-1.576-6.766-4.539-8.341-8.344s-1.574-7.994,0.003-11.798
			l103.908-250.708c1.615-3.895,4.8-6.993,8.739-8.498l97.147-37.118c1.669-0.638,3.366-1.1,5.071-1.401
			c-0.927,7.045-1.679,13.206-2.223,17.824c-3.181,0.182-6.332,0.967-9.305,2.359c-6.13,2.87-10.775,7.956-13.079,14.32
			c-2.305,6.365-1.993,13.245,0.877,19.375c4.303,9.19,13.453,14.592,22.988,14.592c3.593,0,7.243-0.768,10.707-2.39
			c6.13-2.87,10.775-7.957,13.08-14.32c2.304-6.365,1.993-13.245-0.877-19.375c-2.138-4.564-5.506-8.302-9.714-10.867
			c0.558-4.776,1.409-11.819,2.489-20.018c6.492,2.53,12.042,7.461,15.162,14.202l44.512,96.153
			c1.805,3.897,1.896,8.41,0.251,12.378L221.969,487.483c-1.576,3.803-4.539,6.766-8.344,8.341
			c-3.804,1.576-7.994,1.574-11.798-0.002l-92.799-38.461c-3.825-1.588-8.215,0.23-9.801,4.057c-1.585,3.827,0.23,8.215,4.057,9.801
			l92.799,38.461c3.795,1.573,7.732,2.317,11.606,2.317c11.939,0,23.29-7.073,28.137-18.771l20.969-50.591l23.044,49.218
			c5.167,11.028,16.15,17.512,27.591,17.512c4.314,0,8.696-0.922,12.854-2.871l154.316-72.267
			C489.783,427.113,496.356,408.972,489.252,393.782z M259.879,159.363c-0.94,2.596-2.835,4.671-5.337,5.843
			c-5.162,2.418-11.33,0.184-13.748-4.978c-1.171-2.5-1.298-5.308-0.358-7.905c0.94-2.596,2.835-4.671,5.336-5.843
			c1.394-0.653,2.883-0.981,4.378-0.981c1.187,0,2.377,0.207,3.526,0.623c2.596,0.94,4.671,2.835,5.843,5.336
			C260.692,153.96,260.82,156.766,259.879,159.363z M278.778,104.016c-3.362-2.131-7.004-3.786-10.811-4.921
			c3.382-23.407,8.021-50.186,12.853-61.847c3.403-8.213,12.73-26.727,25.797-21.314c13.066,5.416,6.561,25.102,3.156,33.314
			C305.161,60.376,291.562,85.524,278.778,104.016z"/>
	</g>
</g>
<g>
	<g>
		<path d="M154.412,252.893c16.25-8.649,34.896-10.454,52.504-5.077c29.226,8.922,48.843,35.426,48.815,65.952
			c-0.004,4.142,3.351,7.504,7.494,7.508c0.002,0,0.004,0,0.007,0c4.139,0,7.497-3.354,7.501-7.494
			c0.016-17.613-5.713-35.192-16.131-49.5c-10.777-14.799-25.752-25.455-43.307-30.815c-44.259-13.51-91.256,11.504-104.765,55.761
			c-6.545,21.44-4.349,44.144,6.184,63.932c10.532,19.788,28.138,34.29,49.577,40.835c8.013,2.446,16.272,3.66,24.516,3.66
			c11.723,0,23.407-2.458,34.269-7.324c18.317-8.206,33.092-22.676,41.604-40.745c1.766-3.747,0.159-8.217-3.588-9.982
			c-3.747-1.767-8.217-0.159-9.982,3.588c-14.468,30.713-49.906,46.387-82.437,36.454c-17.607-5.374-32.066-17.284-40.716-33.534
			c-8.649-16.25-10.453-34.897-5.077-52.504C126.252,276.002,138.163,261.542,154.412,252.893z"/>
	</g>
</g>
<g>
	<g>
		<path d="M215.643,293.316c-1.795-3.374-4.797-5.848-8.454-6.963l-3.407-1.04l2.315-7.584c1.209-3.962-1.022-8.155-4.983-9.364
			c-3.964-1.207-8.154,1.022-9.364,4.983l-2.367,7.756c-9.993-1.725-19.973,4.211-23.008,14.157
			c-1.594,5.221-1.059,10.751,1.506,15.569c2.564,4.818,6.853,8.351,12.073,9.944l9.442,2.882c1.389,0.424,2.529,1.363,3.211,2.645
			c0.682,1.281,0.824,2.752,0.4,4.141c-0.424,1.388-1.363,2.528-2.645,3.21c-1.281,0.683-2.751,0.825-4.14,0.4l-4.72-1.441
			l-9.95-3.037c0.781-3.753-1.417-7.552-5.156-8.693c-3.964-1.207-8.155,1.022-9.364,4.984c-2.303,7.546,1.961,15.559,9.508,17.864
			l3.408,1.04l-2.315,7.584c-1.209,3.962,1.022,8.155,4.983,9.364c0.73,0.223,1.467,0.329,2.192,0.329
			c3.212,0,6.185-2.08,7.172-5.313l2.365-7.748c1.16,0.202,2.326,0.315,3.49,0.315c3.303,0,6.578-0.81,9.576-2.406
			c4.818-2.564,8.351-6.853,9.944-12.073c3.29-10.778-2.801-22.223-13.579-25.513l-9.442-2.882c-1.388-0.424-2.528-1.363-3.21-2.645
			c-0.682-1.281-0.825-2.752-0.4-4.141c0.874-2.866,3.916-4.488,6.786-3.611l4.717,1.44c0.001,0,0.002,0.001,0.003,0.001
			c0.001,0,0.002,0,0.002,0l9.947,3.037c-0.781,3.752,1.417,7.551,5.156,8.692c3.962,1.209,8.155-1.022,9.364-4.984
			C217.814,300.561,217.439,296.69,215.643,293.316z"/>
	</g>
</g>
<g>
	<g>
		<path d="M439.577,393.388l-48.004-102.009c-1.765-3.749-6.235-5.358-9.98-3.593c-3.748,1.764-5.356,6.233-3.593,9.98
			l48.004,102.009c1.279,2.716,3.976,4.309,6.792,4.309c1.07,0,2.157-0.23,3.188-0.716
			C439.732,401.604,441.34,397.136,439.577,393.388z"/>
	</g>
</g>
<g>
	<g>
		<path d="M406.041,411.323l-48.004-102.009c-1.764-3.749-6.235-5.357-9.98-3.593c-3.748,1.764-5.357,6.233-3.593,9.98
			l48.004,102.009c1.278,2.716,3.976,4.309,6.792,4.309c1.07,0,2.157-0.23,3.188-0.716
			C406.196,419.539,407.804,415.07,406.041,411.323z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
